export default __webpack_public_path__ + "static/media/software-dev-kits.ae4fabec.svg";